// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const AuditResult = t.struct({
    account: t.String,
    creditMemo: t.String,
    description: t.String,
    fiscalYear: t.String
}, {
    name: 'AuditResult',
    strict: true
});

export const getDefaultState = () => new AuditResult({
    account: '',
    creditMemo: '',
    description: '',
    fiscalYear: ''
});

export default AuditResult;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-result.js